import CommonHead, { Metadata } from 'src/components/Common/CommonHead';
import cdn from 'src/common/utils/cdn';

const getMetadata = (): Metadata => {
  const metadata = {
    title: `Beɘk | Audiolibros y meditaciones sin límites`,
    author: 'Beek',
    orgAuthor: 'Beek',
    description:
      'Descarga, escucha y aprende sin cambiar tu rutina con los mejores expertos en finanzas, salud, bienestar, auto ayuda y más.',
    date: '2020-03-02',
    category: 'Audiobooks',
    cover: cdn(
      '/image/landing_page/beek-meta-image.webp?width=1200&height=630&quality=75&format=jpg'
    ),
    url: `https://beek.io`,
    tags: 'Beek',
  };

  return metadata;
};

const LandingPageHeader = (): JSX.Element => {
  const metadata = getMetadata();
  return <CommonHead metadata={metadata} />;
};

export default LandingPageHeader;
